import React from 'react';

const NebulaUltraFeesFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaUltraFeesModalRegistry = {
    personalize_nebulaUltraFeesId: NebulaUltraFeesFormModal
};
export default nebulaUltraFeesModalRegistry;
